import * as React from 'react';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { MasterLockIndividualLock } from '../../../../../api/PropertyIntegration';
import Button from '../../../../common/form/Button';

interface Props {
    lockInfo: MasterLockIndividualLock;
    deleteLock: (deviceIdentifier: string) => Promise<void>;
}

export const MasterLockRow = (props: Props) => (
    <Row className="master-lock-display-row">
        <Col md={3}>
            <span>{props.lockInfo.lockName}</span>
        </Col>
        <Col md={3}>
            <span>{props.lockInfo.displayName}</span>
        </Col>
        <Col md={3}>
            <span>{props.lockInfo.deviceIdentifier}</span>
        </Col>
        <Col md={3} className="delete-button-col">
            <Button
                text="Delete"
                addlClassName="btn-danger"
                onClick={async () => {
                    await props.deleteLock(props.lockInfo.deviceIdentifier);
                }}
                suppressBottomMargin={true}
            />
        </Col>
    </Row>
);

export default MasterLockRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/MasterLockRow.tsx